import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=521e017a&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521e017a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('521e017a')) {
      api.createRecord('521e017a', component.options)
    } else {
      api.reload('521e017a', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=521e017a&scoped=true&", function () {
      api.rerender('521e017a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2IzYD95TKRnpX/JS/comp/SearchFilterTokens.vue"
export default component.exports